import { Directive, Host, OnInit } from '@angular/core';
import { Select } from 'primeng/select';

/**
 * v21 default scrollHeight is 200px (inline) — staging fits short lists without scroll.
 * Cap at 300px via primeng-select.scss / preset.
 */
@Directive({
  selector: 'p-select:not([scrollHeight])',
  standalone: true
})
export class XiroccoSelectDefaultsDirective implements OnInit {
  constructor(@Host() private readonly select: Select) {}

  ngOnInit(): void {
    this.select.scrollHeight = 'auto';
  }
}
